export enum SettingsDialogExtendedKey {
  ACCOUNT = 'account',
  AUDIO = 'audio',
  VIDEO = 'video',
  GENERAL = 'general',
  NOTIFICATIONS = 'notifications',
  TRANSCRIPTION = 'transcription',
  SHORTCUTS = 'shortcuts',
  ACCESSIBILITY = 'accessibility',
}
